export const getNumberOfDays = (date: string) => {
  const currentDate = new Date();
  const pastDate = new Date(date);
  const timeDiff = Math.abs(currentDate.getTime() - pastDate.getTime());
  const daysDifference = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  return daysDifference;
};
